
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gVWoV", function(module, exports) {

$parcel$export(module.exports, "useMessageInstanceEvent", () => $736ffbfc26ebdab1$export$39b0f5626e96f41e);

var $PAiZW = parcelRequire("PAiZW");

var $3Shv6 = parcelRequire("3Shv6");

var $8Bzrf = parcelRequire("8Bzrf");

var $hyvHs = parcelRequire("hyvHs");

var $gwFzn = parcelRequire("gwFzn");

var $76QLI = parcelRequire("76QLI");

var $gXdxk = parcelRequire("gXdxk");
const $736ffbfc26ebdab1$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $gXdxk.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId } = (0, $3Shv6.useMessageContext)();
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $hyvHs.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $gwFzn.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $76QLI.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceViewed = (0, $gwFzn.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $76QLI.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    const messageInstanceClicked = (0, $gwFzn.useCallback)(async (params)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $76QLI.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            ...params,
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...params.additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : params.additionalMetadataFromFrontend,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};

});
parcelRegister("76QLI", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventContextError", () => $cf44d591220b1074$export$9ffc53d3edc152da);
class $cf44d591220b1074$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $cf44d591220b1074$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}

});

parcelRegister("gXdxk", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventClient", () => $49d0938c9296dd55$export$4564cfc2de39be55);
const $49d0938c9296dd55$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("cHGhQ"));
class $49d0938c9296dd55$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($49d0938c9296dd55$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $49d0938c9296dd55$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $49d0938c9296dd55$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("cHGhQ", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $93fa4d7616000b9b$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $93fa4d7616000b9b$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $93fa4d7616000b9b$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $93fa4d7616000b9b$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $93fa4d7616000b9b$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $93fa4d7616000b9b$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $93fa4d7616000b9b$var$support = {
    searchParams: 'URLSearchParams' in $93fa4d7616000b9b$var$g,
    iterable: 'Symbol' in $93fa4d7616000b9b$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $93fa4d7616000b9b$var$g && 'Blob' in $93fa4d7616000b9b$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $93fa4d7616000b9b$var$g,
    arrayBuffer: 'ArrayBuffer' in $93fa4d7616000b9b$var$g
};
function $93fa4d7616000b9b$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($93fa4d7616000b9b$var$support.arrayBuffer) {
    var $93fa4d7616000b9b$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $93fa4d7616000b9b$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $93fa4d7616000b9b$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $93fa4d7616000b9b$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $93fa4d7616000b9b$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $93fa4d7616000b9b$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($93fa4d7616000b9b$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $93fa4d7616000b9b$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $93fa4d7616000b9b$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $93fa4d7616000b9b$var$normalizeName(name);
    value = $93fa4d7616000b9b$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$93fa4d7616000b9b$var$normalizeName(name)];
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $93fa4d7616000b9b$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($93fa4d7616000b9b$var$normalizeName(name));
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$93fa4d7616000b9b$var$normalizeName(name)] = $93fa4d7616000b9b$var$normalizeValue(value);
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $93fa4d7616000b9b$var$iteratorFor(items);
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $93fa4d7616000b9b$var$iteratorFor(items);
};
$93fa4d7616000b9b$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $93fa4d7616000b9b$var$iteratorFor(items);
};
if ($93fa4d7616000b9b$var$support.iterable) $93fa4d7616000b9b$export$79b704688b15c0f4.prototype[Symbol.iterator] = $93fa4d7616000b9b$export$79b704688b15c0f4.prototype.entries;
function $93fa4d7616000b9b$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $93fa4d7616000b9b$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $93fa4d7616000b9b$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $93fa4d7616000b9b$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $93fa4d7616000b9b$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $93fa4d7616000b9b$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $93fa4d7616000b9b$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $93fa4d7616000b9b$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $93fa4d7616000b9b$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($93fa4d7616000b9b$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($93fa4d7616000b9b$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($93fa4d7616000b9b$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($93fa4d7616000b9b$var$support.arrayBuffer && $93fa4d7616000b9b$var$support.blob && $93fa4d7616000b9b$var$isDataView(body)) {
            this._bodyArrayBuffer = $93fa4d7616000b9b$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($93fa4d7616000b9b$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $93fa4d7616000b9b$var$isArrayBufferView(body))) this._bodyArrayBuffer = $93fa4d7616000b9b$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($93fa4d7616000b9b$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($93fa4d7616000b9b$var$support.blob) this.blob = function() {
        var rejected = $93fa4d7616000b9b$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $93fa4d7616000b9b$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($93fa4d7616000b9b$var$support.blob) return this.blob().then($93fa4d7616000b9b$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $93fa4d7616000b9b$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $93fa4d7616000b9b$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($93fa4d7616000b9b$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($93fa4d7616000b9b$var$support.formData) this.formData = function() {
        return this.text().then($93fa4d7616000b9b$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $93fa4d7616000b9b$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $93fa4d7616000b9b$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $93fa4d7616000b9b$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $93fa4d7616000b9b$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $93fa4d7616000b9b$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $93fa4d7616000b9b$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $93fa4d7616000b9b$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $93fa4d7616000b9b$export$79b704688b15c0f4(options.headers);
    this.method = $93fa4d7616000b9b$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $93fa4d7616000b9b$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$93fa4d7616000b9b$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $93fa4d7616000b9b$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $93fa4d7616000b9b$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $93fa4d7616000b9b$var$parseHeaders(rawHeaders) {
    var headers = new $93fa4d7616000b9b$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$93fa4d7616000b9b$var$Body.call($93fa4d7616000b9b$export$7fa6c5b6f8193917.prototype);
function $93fa4d7616000b9b$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $93fa4d7616000b9b$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $93fa4d7616000b9b$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$93fa4d7616000b9b$var$Body.call($93fa4d7616000b9b$export$9f633d56d7ec90d3.prototype);
$93fa4d7616000b9b$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $93fa4d7616000b9b$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $93fa4d7616000b9b$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$93fa4d7616000b9b$export$9f633d56d7ec90d3.error = function() {
    var response = new $93fa4d7616000b9b$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $93fa4d7616000b9b$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$93fa4d7616000b9b$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($93fa4d7616000b9b$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $93fa4d7616000b9b$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $93fa4d7616000b9b$export$fe58bcf938607f6a = $93fa4d7616000b9b$var$g.DOMException;
try {
    new $93fa4d7616000b9b$export$fe58bcf938607f6a();
} catch (err) {
    $93fa4d7616000b9b$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $93fa4d7616000b9b$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $93fa4d7616000b9b$export$fe58bcf938607f6a.prototype.constructor = $93fa4d7616000b9b$export$fe58bcf938607f6a;
}
function $93fa4d7616000b9b$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $93fa4d7616000b9b$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $93fa4d7616000b9b$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $93fa4d7616000b9b$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $93fa4d7616000b9b$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $93fa4d7616000b9b$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $93fa4d7616000b9b$var$g.location.href ? $93fa4d7616000b9b$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($93fa4d7616000b9b$var$support.blob) xhr.responseType = 'blob';
            else if ($93fa4d7616000b9b$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $93fa4d7616000b9b$export$79b704688b15c0f4 || $93fa4d7616000b9b$var$g.Headers && init.headers instanceof $93fa4d7616000b9b$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($93fa4d7616000b9b$var$normalizeName(name));
                xhr.setRequestHeader(name, $93fa4d7616000b9b$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$93fa4d7616000b9b$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$93fa4d7616000b9b$var$g.fetch) {
    $93fa4d7616000b9b$var$g.fetch = $93fa4d7616000b9b$export$e7aa7bc5c1b3cfb3;
    $93fa4d7616000b9b$var$g.Headers = $93fa4d7616000b9b$export$79b704688b15c0f4;
    $93fa4d7616000b9b$var$g.Request = $93fa4d7616000b9b$export$7fa6c5b6f8193917;
    $93fa4d7616000b9b$var$g.Response = $93fa4d7616000b9b$export$9f633d56d7ec90d3;
}

});



parcelRegister("jVJ5P", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $30a6ba7a29ef3ba2$export$3cbbf1e81e2ecb39);

var $cpPWT = parcelRequire("cpPWT");
var $PAiZW = parcelRequire("PAiZW");

var $3Shv6 = parcelRequire("3Shv6");

var $8Bzrf = parcelRequire("8Bzrf");

var $hyvHs = parcelRequire("hyvHs");

var $gwFzn = parcelRequire("gwFzn");

var $60ZhZ = parcelRequire("60ZhZ");

var $adG9I = parcelRequire("adG9I");

var $hwwQB = parcelRequire("hwwQB");
const $30a6ba7a29ef3ba2$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $adG9I.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $cpPWT.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $3Shv6.useMessageContext)();
    const { placementId: placementId } = (0, $8Bzrf.usePlacementContext)();
    const browserContext = (0, $PAiZW.usePostOfficeContext)();
    const recommendationContext = (0, $hyvHs.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $gwFzn.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $hwwQB.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $60ZhZ.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $hwwQB.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $60ZhZ.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $hwwQB.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $60ZhZ.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClicked = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageDismissed = (0, $gwFzn.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $gwFzn.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $60ZhZ.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $hwwQB.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("60ZhZ", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $60ff315a8e8596ab$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $60ff315a8e8596ab$export$44f397e2afeb89e0);
class $60ff315a8e8596ab$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $60ff315a8e8596ab$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("adG9I", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $598d6f0ae3cb5f70$export$ae86a6dabe385178);
const $598d6f0ae3cb5f70$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $598d6f0ae3cb5f70$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("kVxfZ"));
class $598d6f0ae3cb5f70$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $598d6f0ae3cb5f70$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($598d6f0ae3cb5f70$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $598d6f0ae3cb5f70$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $598d6f0ae3cb5f70$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("kVxfZ", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $f3c2eda271730f9c$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $f3c2eda271730f9c$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $f3c2eda271730f9c$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $f3c2eda271730f9c$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $f3c2eda271730f9c$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $f3c2eda271730f9c$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $f3c2eda271730f9c$var$support = {
    searchParams: 'URLSearchParams' in $f3c2eda271730f9c$var$g,
    iterable: 'Symbol' in $f3c2eda271730f9c$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $f3c2eda271730f9c$var$g && 'Blob' in $f3c2eda271730f9c$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $f3c2eda271730f9c$var$g,
    arrayBuffer: 'ArrayBuffer' in $f3c2eda271730f9c$var$g
};
function $f3c2eda271730f9c$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($f3c2eda271730f9c$var$support.arrayBuffer) {
    var $f3c2eda271730f9c$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $f3c2eda271730f9c$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $f3c2eda271730f9c$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $f3c2eda271730f9c$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $f3c2eda271730f9c$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $f3c2eda271730f9c$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($f3c2eda271730f9c$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $f3c2eda271730f9c$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $f3c2eda271730f9c$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $f3c2eda271730f9c$var$normalizeName(name);
    value = $f3c2eda271730f9c$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$f3c2eda271730f9c$var$normalizeName(name)];
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $f3c2eda271730f9c$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($f3c2eda271730f9c$var$normalizeName(name));
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$f3c2eda271730f9c$var$normalizeName(name)] = $f3c2eda271730f9c$var$normalizeValue(value);
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $f3c2eda271730f9c$var$iteratorFor(items);
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $f3c2eda271730f9c$var$iteratorFor(items);
};
$f3c2eda271730f9c$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $f3c2eda271730f9c$var$iteratorFor(items);
};
if ($f3c2eda271730f9c$var$support.iterable) $f3c2eda271730f9c$export$79b704688b15c0f4.prototype[Symbol.iterator] = $f3c2eda271730f9c$export$79b704688b15c0f4.prototype.entries;
function $f3c2eda271730f9c$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $f3c2eda271730f9c$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $f3c2eda271730f9c$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $f3c2eda271730f9c$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $f3c2eda271730f9c$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $f3c2eda271730f9c$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $f3c2eda271730f9c$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $f3c2eda271730f9c$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $f3c2eda271730f9c$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($f3c2eda271730f9c$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($f3c2eda271730f9c$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($f3c2eda271730f9c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($f3c2eda271730f9c$var$support.arrayBuffer && $f3c2eda271730f9c$var$support.blob && $f3c2eda271730f9c$var$isDataView(body)) {
            this._bodyArrayBuffer = $f3c2eda271730f9c$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($f3c2eda271730f9c$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $f3c2eda271730f9c$var$isArrayBufferView(body))) this._bodyArrayBuffer = $f3c2eda271730f9c$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($f3c2eda271730f9c$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($f3c2eda271730f9c$var$support.blob) this.blob = function() {
        var rejected = $f3c2eda271730f9c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $f3c2eda271730f9c$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($f3c2eda271730f9c$var$support.blob) return this.blob().then($f3c2eda271730f9c$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $f3c2eda271730f9c$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $f3c2eda271730f9c$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($f3c2eda271730f9c$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($f3c2eda271730f9c$var$support.formData) this.formData = function() {
        return this.text().then($f3c2eda271730f9c$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $f3c2eda271730f9c$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $f3c2eda271730f9c$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $f3c2eda271730f9c$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $f3c2eda271730f9c$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $f3c2eda271730f9c$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $f3c2eda271730f9c$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $f3c2eda271730f9c$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $f3c2eda271730f9c$export$79b704688b15c0f4(options.headers);
    this.method = $f3c2eda271730f9c$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $f3c2eda271730f9c$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$f3c2eda271730f9c$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $f3c2eda271730f9c$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $f3c2eda271730f9c$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $f3c2eda271730f9c$var$parseHeaders(rawHeaders) {
    var headers = new $f3c2eda271730f9c$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$f3c2eda271730f9c$var$Body.call($f3c2eda271730f9c$export$7fa6c5b6f8193917.prototype);
function $f3c2eda271730f9c$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $f3c2eda271730f9c$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $f3c2eda271730f9c$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$f3c2eda271730f9c$var$Body.call($f3c2eda271730f9c$export$9f633d56d7ec90d3.prototype);
$f3c2eda271730f9c$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $f3c2eda271730f9c$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $f3c2eda271730f9c$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$f3c2eda271730f9c$export$9f633d56d7ec90d3.error = function() {
    var response = new $f3c2eda271730f9c$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $f3c2eda271730f9c$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$f3c2eda271730f9c$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($f3c2eda271730f9c$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $f3c2eda271730f9c$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $f3c2eda271730f9c$export$fe58bcf938607f6a = $f3c2eda271730f9c$var$g.DOMException;
try {
    new $f3c2eda271730f9c$export$fe58bcf938607f6a();
} catch (err) {
    $f3c2eda271730f9c$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $f3c2eda271730f9c$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $f3c2eda271730f9c$export$fe58bcf938607f6a.prototype.constructor = $f3c2eda271730f9c$export$fe58bcf938607f6a;
}
function $f3c2eda271730f9c$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $f3c2eda271730f9c$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $f3c2eda271730f9c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $f3c2eda271730f9c$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $f3c2eda271730f9c$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $f3c2eda271730f9c$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $f3c2eda271730f9c$var$g.location.href ? $f3c2eda271730f9c$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($f3c2eda271730f9c$var$support.blob) xhr.responseType = 'blob';
            else if ($f3c2eda271730f9c$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $f3c2eda271730f9c$export$79b704688b15c0f4 || $f3c2eda271730f9c$var$g.Headers && init.headers instanceof $f3c2eda271730f9c$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($f3c2eda271730f9c$var$normalizeName(name));
                xhr.setRequestHeader(name, $f3c2eda271730f9c$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$f3c2eda271730f9c$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$f3c2eda271730f9c$var$g.fetch) {
    $f3c2eda271730f9c$var$g.fetch = $f3c2eda271730f9c$export$e7aa7bc5c1b3cfb3;
    $f3c2eda271730f9c$var$g.Headers = $f3c2eda271730f9c$export$79b704688b15c0f4;
    $f3c2eda271730f9c$var$g.Request = $f3c2eda271730f9c$export$7fa6c5b6f8193917;
    $f3c2eda271730f9c$var$g.Response = $f3c2eda271730f9c$export$9f633d56d7ec90d3;
}

});


parcelRegister("hwwQB", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $bdfc318f2434f78e$export$b31ffc6f7c85f1b);
var $bdfc318f2434f78e$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});


parcelRegister("crDNP", function(module, exports) {

$parcel$export(module.exports, "ManualMessageViewedEvent", () => $b9b497d1215dcd3f$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $b9b497d1215dcd3f$export$14fe1fc3395b6e3f);

var $7UHDa = parcelRequire("7UHDa");

var $gVWoV = parcelRequire("gVWoV");

var $jVJ5P = parcelRequire("jVJ5P");

var $gwFzn = parcelRequire("gwFzn");

var $e4z5D = parcelRequire("e4z5D");

var $aEUWC = parcelRequire("aEUWC");

var $fUB5z = parcelRequire("fUB5z");
const $b9b497d1215dcd3f$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $aEUWC.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
const $b9b497d1215dcd3f$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $aEUWC.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $gVWoV.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $gwFzn.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $gwFzn.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $gwFzn.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUB5z.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $b9b497d1215dcd3f$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $gwFzn.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $gVWoV.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $e4z5D.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $gwFzn.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $gwFzn.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $7UHDa.jsx)($b9b497d1215dcd3f$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};

});
parcelRegister("e4z5D", function(module, exports) {

$parcel$export(module.exports, "useInViewport", () => $a3eca88bfadafe60$export$6215040b989f9b0f, (v) => $a3eca88bfadafe60$export$6215040b989f9b0f = v);
var $a3eca88bfadafe60$export$1e511d4a378977f5;
var $a3eca88bfadafe60$export$6215040b989f9b0f;
var $a3eca88bfadafe60$export$436b63fa4855237f;
var $a3eca88bfadafe60$export$2e2bcd8739ae039;
var $a3eca88bfadafe60$export$95cef81be5ddcfd4;
"use strict";
$a3eca88bfadafe60$export$1e511d4a378977f5 = true;
$a3eca88bfadafe60$export$6215040b989f9b0f = $a3eca88bfadafe60$export$436b63fa4855237f = $a3eca88bfadafe60$export$2e2bcd8739ae039 = $a3eca88bfadafe60$export$95cef81be5ddcfd4 = void 0;

var $a3eca88bfadafe60$var$_handleViewport = $a3eca88bfadafe60$var$_interopRequireDefault((parcelRequire("7bgtm")));
$a3eca88bfadafe60$export$436b63fa4855237f = $a3eca88bfadafe60$var$_handleViewport.default;

var $a3eca88bfadafe60$var$_useInViewport = $a3eca88bfadafe60$var$_interopRequireDefault((parcelRequire("jwZdQ")));
$a3eca88bfadafe60$export$6215040b989f9b0f = $a3eca88bfadafe60$var$_useInViewport.default;
function $a3eca88bfadafe60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $a3eca88bfadafe60$var$customProps = $a3eca88bfadafe60$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $a3eca88bfadafe60$var$_default = $a3eca88bfadafe60$export$2e2bcd8739ae039 = $a3eca88bfadafe60$var$_handleViewport.default;

});
parcelRegister("7bgtm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $53a656998ae05270$export$1e511d4a378977f5, (v) => $53a656998ae05270$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $53a656998ae05270$export$2e2bcd8739ae039, (v) => $53a656998ae05270$export$2e2bcd8739ae039 = v);
var $53a656998ae05270$export$1e511d4a378977f5;
var $53a656998ae05270$export$2e2bcd8739ae039;
"use strict";
$53a656998ae05270$export$1e511d4a378977f5 = true;
$53a656998ae05270$export$2e2bcd8739ae039 = void 0;

var $gwFzn = parcelRequire("gwFzn");

var $53a656998ae05270$var$_hoistNonReactStatics = $53a656998ae05270$var$_interopRequireDefault((parcelRequire("TPNsL")));

var $53a656998ae05270$var$_useInViewport = $53a656998ae05270$var$_interopRequireDefault((parcelRequire("jwZdQ")));

var $92yYb = parcelRequire("92yYb");

var $7UHDa = parcelRequire("7UHDa");
var $53a656998ae05270$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $53a656998ae05270$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $53a656998ae05270$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $53a656998ae05270$var$_extends() {
    return $53a656998ae05270$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $53a656998ae05270$var$_extends.apply(null, arguments);
}
function $53a656998ae05270$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $92yYb.defaultOptions;
    if (config === void 0) config = $92yYb.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)(TargetComponent, $53a656998ae05270$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $92yYb.noop, onLeaveViewport: onLeaveViewport = $92yYb.noop } = _ref, restProps = $53a656998ae05270$var$_objectWithoutPropertiesLoose(_ref, $53a656998ae05270$var$_excluded);
        var node = (0, $gwFzn.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $53a656998ae05270$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $53a656998ae05270$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)(ForwardedRefComponent, $53a656998ae05270$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $53a656998ae05270$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $53a656998ae05270$var$_default = $53a656998ae05270$export$2e2bcd8739ae039 = $53a656998ae05270$var$handleViewport;

});
parcelRegister("jwZdQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e3807eef76a32697$export$1e511d4a378977f5, (v) => $e3807eef76a32697$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e3807eef76a32697$export$2e2bcd8739ae039, (v) => $e3807eef76a32697$export$2e2bcd8739ae039 = v);
var $e3807eef76a32697$export$1e511d4a378977f5;
var $e3807eef76a32697$export$2e2bcd8739ae039;
"use strict";
$e3807eef76a32697$export$1e511d4a378977f5 = true;
$e3807eef76a32697$export$2e2bcd8739ae039 = void 0;

var $gwFzn = parcelRequire("gwFzn");

var $92yYb = parcelRequire("92yYb");
var $e3807eef76a32697$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $e3807eef76a32697$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $92yYb.defaultOptions;
    if (config === void 0) config = $92yYb.defaultConfig;
    if (props === void 0) props = $92yYb.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $gwFzn.useState)();
    var observer = (0, $gwFzn.useRef)();
    var inViewportRef = (0, $gwFzn.useRef)(false);
    var intersected = (0, $gwFzn.useRef)(false);
    var enterCountRef = (0, $gwFzn.useRef)(0);
    var leaveCountRef = (0, $gwFzn.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $gwFzn.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $gwFzn.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $gwFzn.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $e3807eef76a32697$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $e3807eef76a32697$var$_default = $e3807eef76a32697$export$2e2bcd8739ae039 = $e3807eef76a32697$var$useInViewport;

});
parcelRegister("92yYb", function(module, exports) {

$parcel$export(module.exports, "noop", () => $694f6d32a078f205$export$8793edee2d425525, (v) => $694f6d32a078f205$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $694f6d32a078f205$export$9c21a3269931e1e6, (v) => $694f6d32a078f205$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $694f6d32a078f205$export$ba43bf67f3d48107, (v) => $694f6d32a078f205$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $694f6d32a078f205$export$f84bd70098573c5c, (v) => $694f6d32a078f205$export$f84bd70098573c5c = v);
var $694f6d32a078f205$export$1e511d4a378977f5;
var $694f6d32a078f205$export$8793edee2d425525;
var $694f6d32a078f205$export$9c21a3269931e1e6;
var $694f6d32a078f205$export$ba43bf67f3d48107;
var $694f6d32a078f205$export$f84bd70098573c5c;
"use strict";
$694f6d32a078f205$export$1e511d4a378977f5 = true;
$694f6d32a078f205$export$8793edee2d425525 = $694f6d32a078f205$export$9c21a3269931e1e6 = $694f6d32a078f205$export$ba43bf67f3d48107 = $694f6d32a078f205$export$f84bd70098573c5c = void 0;
var $694f6d32a078f205$var$defaultOptions = $694f6d32a078f205$export$ba43bf67f3d48107 = {};
var $694f6d32a078f205$var$defaultConfig = $694f6d32a078f205$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $694f6d32a078f205$var$noop = ()=>{};
$694f6d32a078f205$export$8793edee2d425525 = $694f6d32a078f205$var$noop;
var $694f6d32a078f205$var$defaultProps = $694f6d32a078f205$export$9c21a3269931e1e6 = {
    onEnterViewport: $694f6d32a078f205$var$noop,
    onLeaveViewport: $694f6d32a078f205$var$noop
};

});






//# sourceMappingURL=render.93a6e854.js.map
